// export const dicoSalesVats = {
//     "000": {},
//     "002": { key: "02", vatRate: 2.1 },
//     "005": { key: "05", vatRate: 5.5 },
//     "008": { key: "08", vatRate: 8.5 }, //TAUX TVA 8.5
//     "010": { key: "10", vatRate: 10.0 },
//     "020": { key: "20", vatRate: 20.0 },
//     "030": { key: "30", vatRate: 0.0, vatType: "INTRACOM" },
//     "060": { key: "80", vatRate: 0.0, vatType: "EXPORT" }, // OBSOLETE
//     "080": { key: "80", vatRate: 0.0, vatType: "EXPORT" },
//     "090": { key: "90", vatRate: 0.0, vatType: "REVERSE_CHARGE" },
//     "050": { key: "50" },
//     "700": {},
//     "702": { key: "02", vatRate: 2.1 },
//     "705": { key: "05", vatRate: 5.5 },
//     "708": { key: "08", vatRate: 8.5 }, //TAUX TVA 8.5
//     "710": { key: "10", vatRate: 10.0 },
//     "720": { key: "20", vatRate: 20.0 },
//     "730": { vatRate: 0.0 },
//     "780": { vatRate: 0.0 }
// }

// export function getSalesVateRate(accountableAccount) {
//     if (accountableAccount.startsWith("7") || accountableAccount.startsWith("4457")) {
//         // const rootAA = accountableAccount.substring(0, 3);
//         const vatKey = accountableAccount.substring(3);
//         return dicoSalesVats[vatKey];
//     }
//     return undefined
// }

// export function getAASuffix(vatRate) {
//     if (vatRate !== null && vatRate !== undefined) {
//         if (vatRate === 2.1) {
//             return "02"
//         } if (vatRate === 5.5) {
//             return "05"
//         } if (vatRate === 8.5) {
//             return "08" // TAUX TVA 8.5
//         } if (vatRate === 10.0) {
//             return "10"
//         } if (vatRate === 20.0) {
//             return "20"
//         } if (vatRate === 0.0) {
//             return "00"
//         }
//         debugger;
//         return "30"
//     }
//     return "000"
// }

import { filterAccountableAccounts } from "../../../backend/src/common/accountableAccount/accountableAccountServices";

export async function getVatAAs(accountableAccountTable) {
    let vatAAs = [];
    if (accountableAccountTable) {
        vatAAs = filterAccountableAccounts(accountableAccountTable, ["445", "70"], []);
    }
    if (!vatAAs.length) {
        debugger;
        console.error("Error getting vat accountable accounts");
    }
    return vatAAs;
}

export const vatRatesAudit = [
    { value: "20", text: "20%" },
    { value: "10", text: "10%" },
    { value: "08", text: "8,5%" },
    { value: "05", text: "5,5%" },
    { value: "02", text: "2,1%" },
];

export const vatRatesInvoice = [
    { value: "20", text: "20%" },
    { value: "10", text: "10%" },
    { value: "8.5", text: "8,5%" },
    { value: "5.5", text: "5,5%" },
    { value: "2.1", text: "2,1%" },
    { value: "0", text: "0%" },
];

export const vatRatesAccountableAccount = [
    ...vatRatesInvoice.map((vat) => ({
        value: parseFloat(vat.value),
        text: vat.text,
    })),
    { value: null, text: "" },
];

export const vatListTicketZ: any[] = [
    ...vatRatesInvoice.map((vat) => ({
        title: vat.text,
        value: parseFloat(vat.value),
    })),
    { value: "0INTRACOM", title: "0 - Intracom" }, // not vat accountable account (income)
];

export function vatListDocument(documentType: string) {
    const vatList = [
        ...vatRatesInvoice.filter((item) => item.value !== "0"),
        { value: "0", text: "0 - Inconnue", disabled: true },
        { value: "0NO_VAT_TYPE", text: "0 - Aucun" },
        { value: "0INTRACOM", text: "0 - Intracom" }, // not vat accountable account (subAmount)
        { value: "0REVERSE_CHARGE", text: "0 - Autoliquidation" },
    ];
    if (documentType === "SALES_INVOICE") {
        vatList.push({ value: "0EXPORT", text: "0 - Export" });
    } else {
        vatList.push({ value: "0IMPORT", text: "0 - Import" });
        vatList.push({ value: "custom", text: "Libre" });
    }
    return vatList;
}

export function vatListDocumentDiscount(documentType: string) {
    if (documentType !== "SALES_INVOICE") {
        return [
            { value: "20", text: "20%" },
            { value: "10", text: "10%", disabled: true },
            { value: "8.5", text: "8,5%", disabled: true },
            { value: "5.5", text: "5,5%", disabled: true },
            { value: "2.1", text: "2,1%", disabled: true },
            { value: "0", text: "0 - Inconnue", disabled: true },
            { value: "0NO_VAT_TYPE", text: "0 - Aucun" },
            { value: "0INTRACOM", text: "0 - Intracom", disabled: true }, // not vat accountable account (subAmount)
            { value: "0EXPORT", text: "0 - Export", disabled: true },
            { value: "0IMPORT", text: "0 - Import", disabled: true },
            { value: "0REVERSE_CHARGE", text: "0 - Autoliquidation", disabled: true },
            { value: "custom", text: "Libre" },
        ];
    }
    return vatRatesInvoice;
}

export const vatRatesReconciliation = [
    { value: -1, text: "Sans TVA" },
    ...vatRatesInvoice.map((vat) => ({
        value: parseFloat(vat.value),
        text: vat.text,
    })),
];

export const vatRatesZTillReceipt = [
    ...vatRatesInvoice.filter((item) => item.value !== "0"),
    { value: "0", text: "0 - Inconnue", disabled: true },
    { value: "0NO_VAT_TYPE", text: "0 - Aucun" },
];

export function vatListIncomingOutgoingPayment(documentType) {
    const vats = [
        { value: "20", vatRate: 20, text: "20%" },
        { value: "10", vatRate: 10, text: "10%" },
        { value: "8.5", vatRate: 8.5, text: "8,5%" },
        { value: "5.5", vatRate: 5.5, text: "5,5%" },
        { value: "2.1", vatRate: 2.1, text: "2,1%" },
        { value: "0NO_VAT_TYPE", vatRate: 0, text: "0 - Aucun" },
        { value: "0INTRACOM", vatRate: 0, text: "0 - Intracom" }, // not vat accountable account (document)
        { value: "0REVERSE_CHARGE", vatRate: 0, text: "0 - Autoliquidation" },
    ];
    if (documentType === "SALES_INVOICE") {
        vats.push({ value: "0EXPORT", vatRate: 0, text: "0 - Export" });
    } else {
        vats.push({ value: "0IMPORT", vatRate: 0, text: "0 - Import" });
    }
    return vats;
}

export const vatListWordingAnalysis = [
    { value: "0", vatType: null, vatRate: null, title: "Pas de TVA" },
    { value: "20", vatType: null, vatRate: 20, title: "20%" },
    { value: "10", vatType: null, vatRate: 10, title: "10%" },
    { value: "8.5", vatType: null, vatRate: 8.5, title: "8,5%" },
    { value: "5.5", vatType: null, vatRate: 5.5, title: "5,5%" },
    { value: "2.1", vatType: null, vatRate: 2.1, title: "2,1%" },
    { value: "0NO_VAT_TYPE", vatType: "NO_VAT_TYPE", vatRate: 0, title: "0 - Aucun" },
    { value: "0INTRACOM", vatType: "INTRACOM", vatRate: 0, title: "0 - Intracom" }, // not vat accountable account (bankTransactionWordingPattern)
    { value: "0IMPORT", vatType: "IMPORT", vatRate: 0, title: "0 - Import" },
    {
        value: "0REVERSE_CHARGE",
        vatType: "REVERSE_CHARGE",
        vatRate: 0,
        title: "0 - Autoliquidation",
    },
];

export const vatTypesForSalesAA = [
    { value: "NO_VAT_TYPE", text: "" },
    { value: "INTRACOM", text: "Intracom" }, // not vat accountable account (sales account)
    { value: "IMPORT", text: "Import" },
    { value: "EXPORT", text: "Export" },
    { value: "REVERSE_CHARGE", text: "Autoliquidation" },
];

export const vatTypesForVatAA = [
    { value: "NO_VAT_TYPE", text: "" },
    { value: "INTRACOM_DEBIT", text: "Intracom débit" },
    { value: "INTRACOM_CREDIT", text: "Intracom crédit" },
    { value: "IMPORT_DEBIT", text: "Import débit" },
    { value: "IMPORT_CREDIT", text: "Import crédit" },
    { value: "EXPORT", text: "Export" },
    { value: "REVERSE_CHARGE_DEBIT", text: "Autoliquidation débit" },
    { value: "REVERSE_CHARGE_CREDIT", text: "Autoliquidation crédit" },
];
